import { useTheme } from '@mui/material'

export const useLoginScreenStyle = () => {
    const theme = useTheme()
    const primaryMain = theme.palette.primary.main
    const fontColor = 'white'
    const containerStyle = {
        zIndex: 0,
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    }
    const backgroundImageContainerStyle = {
        position: 'absolute',
        maxHeight: '100vh',
        overflow: 'hidden',
        top: '0px',
        left: '0px',
        opacity: '0.3',
        filter: 'blur(10px)',
    }
    const logoStyle = {
        maxWidth: '271px',
        zIndex: 1,
        '& > img': {
            width: '100%',
        },
    }
    const contentStyle = {
        marginTop: '20px',
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 1,
    }
    const menusContainerStyle = {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: {
            xs: 'column',
            md: 'row',
        },
        justifyContent: 'center',
        padding: { xs: '16px', md: '40px' },
    }
    const headerStyle = {
        marginTop: '40px',
        color: fontColor,
        typography: 'headline2',
        zIndex: 1,
    }

    const subtitle1Style = {
        textAlign: { xs: 'center', md: 'unset' },
        typography: 'headline2',
        marginBottom: '20px',
        marginTop: '40px',
        color: fontColor,
        zIndex: 1,
        minWidth: { xs: 'unset', md: '900px' },
        padding: { xs: '0 16px', md: 0 },
    }
    const subtitle2Style = {
        textAlign: { xs: 'center', md: 'unset' },
        zIndex: 1,
        typography: 'label2',
        color: fontColor,
        marginTop: '20px',
        marginBottom: '40px',
    }

    const colorButtonStyle = {
        color: fontColor,
        borderRadius: '25px',
        background: `${primaryMain}`,
        paddingTop: '5px',
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingBottom: '6px',
        minWidth: '130px',
        typography: 'text1',
        textTransform: 'none',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: `${primaryMain}`,
        },
    }

    const underLineButtonStyle = {
        color: fontColor,
        typography: 'text2',
        textDecoration: 'underline',
        textTransform: 'none',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'transparent',
        },
        marginTop: '20px',
    }
    const verticalLineStyle = {
        display: { xs: 'none', md: 'block' },
        position: 'absolute',
        height: '90%',
        borderLeft: '1px solid',
        transform: {
            xs: 'rotate(90deg)',
            md: 'unset',
        },
    }
    const loginMenuContainer = {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        right: { xs: 'unset', md: '180px' },
        minWidth: '350px',
        alignItems: 'center',
        height: '100%',
        marginBottom: { xs: '40px', md: 'unset' },
    }

    const buttonContainerStyles = {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '20px',
        position: 'relative',
    }

    const inputContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
    }
    return {
        containerStyle,
        backgroundImageContainerStyle,
        logoStyle,
        underLineButtonStyle,
        colorButtonStyle,
        menusContainerStyle,
        subtitle1Style,
        subtitle2Style,
        headerStyle,
        contentStyle,
        verticalLineStyle,
        loginMenuContainer,
        buttonContainerStyles,
        inputContainerStyle,
    }
}
